/* Source: /app/components/Mobile/MobilePanelRouter.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { CodePanel } from "./MobilePanels/CodePanel.js";
import { GraphPanel } from "./MobilePanels/GraphPanel.js";
import { OutputPanel } from "./MobilePanels/OutputPanel.js";
import { ExamplesPanel } from "./MobilePanels/ExamplesPanel.js";
function MobilePanelRouter(props) {
  let activePanel = (props.activePanel || "code");
  let mode = (props.mode || "jac");
  let editorTheme = (props.editorTheme || "vs-light");
  let isDarkMode = (props.isDarkMode || false);
  let codeValue = (props.codeValue || "");
  let onCodeChange = props.onCodeChange;
  let outputCode = (props.outputCode || "");
  let onRun = props.onRun;
  let isRunning = (props.isRunning || false);
  let envReady = (props.envReady || false);
  let graphData = props.graphData;
  let output = (props.output || "");
  let errors = (props.errors || "");
  let logs = (props.logs || "");
  let onClearOutput = props.onClearOutput;
  let onClearErrors = props.onClearErrors;
  let onClearLogs = props.onClearLogs;
  let examples = (props.examples || []);
  let onSelectExample = props.onSelectExample;
  if ((activePanel === "code")) {
    return __jacJsx(CodePanel, {"mode": mode, "value": codeValue, "onChange": onCodeChange, "outputValue": outputCode, "onRun": onRun, "isRunning": isRunning, "editorTheme": editorTheme, "envReady": envReady}, []);
  }
  if ((activePanel === "graph")) {
    return __jacJsx(GraphPanel, {"graphData": graphData, "isDarkMode": isDarkMode}, []);
  }
  if ((activePanel === "output")) {
    return __jacJsx(OutputPanel, {"output": output, "errors": errors, "logs": logs, "onClearOutput": onClearOutput, "onClearErrors": onClearErrors, "onClearLogs": onClearLogs}, []);
  }
  if ((activePanel === "examples")) {
    return __jacJsx(ExamplesPanel, {"examples": examples, "onSelectExample": onSelectExample}, []);
  }
  return null;
}
export {MobilePanelRouter};